// get请求从config.url获取参数，post从config.body中获取参数
function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"') +
    '"}'
  )
}

/* exhibitionA1基本陈列开始 */
let List = []
// const count = 25
//模拟100条数据
// for (let i = 0; i < count; i++) {
  List.push({
    id : '10',
    title : '举重源流',
    date : '永久',
    address : '新体馆三楼古代厅',
    classify : '古代篇',
    picUrl : 'https://www.cwmuseum.cn/img/Exhibition04@2x.png',
  },{
    id : '12',
    title : '竞技引入',
    date : '永久',
    address : '新体馆三楼近代篇',
    classify : '近代篇',
    picUrl : 'https://www.cwmuseum.cn/img/Exhibition05@2x.png',
  },{
    id : '13',
    title : '科学举重',
    date : '永久',
    address : '新体馆三楼技术篇',
    classify : '技术篇',
    picUrl : 'https://www.cwmuseum.cn/img/Exhibition06@2x.png',
  },{
    id : '14',
    title : '荣光闪耀',
    date : '永久',
    address : '新体馆三楼现代篇',
    classify : '现代篇',
    picUrl : 'https://www.cwmuseum.cn/img/Exhibition07@2x.png',
  })
// }
let Detail = [{
  id : '10',
  title : '举重源流',
  date : '永久',
  address : '新体馆三楼古代厅',
  classify : '古代篇',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner10@2x.png',
  picUrl_Nei : 'https://www.cwmuseum.cn/img/ExhibitionA1Detail02@2x.png',
  detail1 : '              举重起源于古埃及，公元四千多年前古埃及人通过举沙袋来锻炼身体。但真正意义上的现代举重运动起源于英国。18世纪时，英国的马戏班里就有举重的表演，19世纪初，英国还成立了举重的俱乐部，而且现代首次举重比赛是在英国举行的。\n' +
    '              <br/>\n' +
    '              <br/>\n' +
    '              举重这一项目具有悠久的历史，是指将杠铃以双手举过头顶，胜负以杠铃的重量为依据的体育项目。举重最早是作为人们锻炼身体的一种方式，一开始举的也不是杠铃，而是各种各样的重物。1896年在希腊举行了国际上第一次正式的举重比赛。而且男子举重在第一届奥林匹克运动会上就被列为了正式项目，女子举重在2000年的悉尼奥运会上才被列入正式项目。',
  detail2 : '              <img src="https://www.cwmuseum.cn/img/ExhibitionA1Detail03@2x.png" alt="">\n' +
    '              <br/>\n' +
    '              <br/>\n' +
    '              <img src="https://www.cwmuseum.cn/img/ExhibitionA1Detail04@2x.png" alt="">'
},{
  id : '12',
  title : '竞技引入',
  date : '永久',
  address : '新体馆三楼近代篇',
  classify : '近代篇',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner10@2x.png',
  picUrl_Nei : 'https://www.cwmuseum.cn/img/ExhibitionA1Detail02@2x.png',
  detail1 : '              举重起源于古埃及，公元四千多年前古埃及人通过举沙袋来锻炼身体。但真正意义上的现代举重运动起源于英国。18世纪时，英国的马戏班里就有举重的表演，19世纪初，英国还成立了举重的俱乐部，而且现代首次举重比赛是在英国举行的。\n' +
    '              <br/>\n' +
    '              <br/>\n' +
    '              举重这一项目具有悠久的历史，是指将杠铃以双手举过头顶，胜负以杠铃的重量为依据的体育项目。举重最早是作为人们锻炼身体的一种方式，一开始举的也不是杠铃，而是各种各样的重物。1896年在希腊举行了国际上第一次正式的举重比赛。而且男子举重在第一届奥林匹克运动会上就被列为了正式项目，女子举重在2000年的悉尼奥运会上才被列入正式项目。',
  detail2 : '              <img src="https://www.cwmuseum.cn/img/ExhibitionA1Detail03@2x.png" alt="">\n' +
    '              <br/>\n' +
    '              <br/>\n' +
    '              <img src="https://www.cwmuseum.cn/img/ExhibitionA1Detail04@2x.png" alt="">'
},{
  id : '13',
  title : '科学举重',
  date : '永久',
  address : '新体馆三楼技术篇',
  classify : '技术篇',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner10@2x.png',

  picUrl_Nei : 'https://www.cwmuseum.cn/img/ExhibitionA1Detail02@2x.png',
  detail1 : '              举重起源于古埃及，公元四千多年前古埃及人通过举沙袋来锻炼身体。但真正意义上的现代举重运动起源于英国。18世纪时，英国的马戏班里就有举重的表演，19世纪初，英国还成立了举重的俱乐部，而且现代首次举重比赛是在英国举行的。\n' +
    '              <br/>\n' +
    '              <br/>\n' +
    '              举重这一项目具有悠久的历史，是指将杠铃以双手举过头顶，胜负以杠铃的重量为依据的体育项目。举重最早是作为人们锻炼身体的一种方式，一开始举的也不是杠铃，而是各种各样的重物。1896年在希腊举行了国际上第一次正式的举重比赛。而且男子举重在第一届奥林匹克运动会上就被列为了正式项目，女子举重在2000年的悉尼奥运会上才被列入正式项目。',
  detail2 : '              <img src="https://www.cwmuseum.cn/img/ExhibitionA1Detail03@2x.png" alt="">\n' +
    '              <br/>\n' +
    '              <br/>\n' +
    '              <img src="https://www.cwmuseum.cn/img/ExhibitionA1Detail04@2x.png" alt="">'
},{
  id : '14',
  title : '荣光闪耀',
  date : '永久',
  address : '新体馆三楼现代篇',
  classify : '现代篇',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner10@2x.png',
  picUrl_Nei : 'https://www.cwmuseum.cn/img/ExhibitionA1Detail02@2x.png',
  detail1 : '              举重起源于古埃及，公元四千多年前古埃及人通过举沙袋来锻炼身体。但真正意义上的现代举重运动起源于英国。18世纪时，英国的马戏班里就有举重的表演，19世纪初，英国还成立了举重的俱乐部，而且现代首次举重比赛是在英国举行的。\n' +
    '              <br/>\n' +
    '              <br/>\n' +
    '              举重这一项目具有悠久的历史，是指将杠铃以双手举过头顶，胜负以杠铃的重量为依据的体育项目。举重最早是作为人们锻炼身体的一种方式，一开始举的也不是杠铃，而是各种各样的重物。1896年在希腊举行了国际上第一次正式的举重比赛。而且男子举重在第一届奥林匹克运动会上就被列为了正式项目，女子举重在2000年的悉尼奥运会上才被列入正式项目。',
  detail2 : '              <img src="https://www.cwmuseum.cn/img/ExhibitionA1Detail03@2x.png" alt="">\n' +
    '              <br/>\n' +
    '              <br/>\n' +
    '              <img src="https://www.cwmuseum.cn/img/ExhibitionA1Detail04@2x.png" alt="">'
}]
/* exhibitionA1基本陈列结束 */
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/* exhibitionA2特别展览开始 */
let List2 = []
List2.push({
  id : '10',
  title : '美洲豹的传人-墨西哥古代...',
  date : '2025.05.10-2024.05.31',
  address : '中国举重博物馆一楼临时展厅',
  isShow : 1, // 1 展览中 2已结束
  picUrl : 'https://www.cwmuseum.cn/img/Exhibition09@2x.png',
  isNeed : 1, // 1 需要预约
},{
  id : '11',
  title : '“美好新时代·湘鄂赣一家亲”...',
  date : '2025.05.10-2024.05.31',
  address : '中国举重博物馆一楼临时展厅',
  isShow : 1, // 1 展览中 2已结束
  picUrl : 'https://www.cwmuseum.cn/img/Exhibition10@2x.png',
  isNeed : 1, // 1 需要预约
},{
  id : '12',
  title : '扇里·扇外——湖南博物院藏...',
  date : '2025.05.10-2024.05.31',
  address : '中国举重博物馆一楼临时展厅',
  isShow : 1, // 1 展览中 2已结束
  picUrl : 'https://www.cwmuseum.cn/img/Exhibition11@2x.png',
  isNeed : 1, // 1 需要预约
},{
  id : '13',
  title : '无尽藏——苏轼的书画艺术...',
  date : '2025.05.10-2024.05.31',
  address : '中国举重博物馆一楼临时展厅',
  isShow : 2, // 1 展览中 2已结束
  picUrl : 'https://www.cwmuseum.cn/img/Exhibition12@2x.png',
  isNeed : 1, // 1 需要预约
},{
  id : '14',
  title : '“宇宙猜想·启程”大型宇宙探...',
  date : '2025.05.10-2024.05.31',
  address : '中国举重博物馆一楼临时展厅',
  isShow : 2, // 1 展览中 2已结束
  picUrl : 'https://www.cwmuseum.cn/img/Exhibition13@2x.png',
  isNeed : 1, // 1 需要预约
},{
  id : '15',
  title : '北方有佳人——内蒙古自治...',
  date : '2025.05.10-2024.05.31',
  address : '中国举重博物馆一楼临时展厅',
  isShow : 2, // 1 展览中 2已结束
  picUrl : 'https://www.cwmuseum.cn/img/Exhibition14@2x.png',
  isNeed : 1, // 1 需要预约
})
let Detail2 = [{
  id : '10',
  title : '扇里·扇外——中国举重博物馆藏扇面展',
  date : '2024.01.01. 09:00—2024.12.31 17:00',
  address : '中国剧中博物馆一楼临展厅',
  classify : '特展',
  ticketPrice :'免费',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner11@2x.png',
  picUrl_Nei : 'https://www.cwmuseum.cn/img/ExhibitionA1Detail05@2x.png',
  summary : '自从极具美学灵性的宋人开始在纨扇上挥洒丹青，扇画便逐渐成为中国书画艺术的新形式。有明一代，便于携带的“聚头”折扇风靡流行，可供赏阅亦可把玩的扇子，成为士大夫所推崇的随身雅物。清至民国，在往来应酬的文化交流中，官员世士们更是争相以画扇、赠扇、藏扇为趣，以此彰显个人的才气品位与身份地位。',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  proList: [{
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  }]
},{
  id : '11',
  title : '扇里·扇外——中国举重博物馆藏扇面展',
  date : '2024.01.01. 09:00—2024.12.31 17:00',
  address : '中国剧中博物馆一楼临展厅',
  classify : '特展',
  ticketPrice :'免费',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner11@2x.png',
  picUrl_Nei : 'https://www.cwmuseum.cn/img/ExhibitionA1Detail05@2x.png',
  summary : '自从极具美学灵性的宋人开始在纨扇上挥洒丹青，扇画便逐渐成为中国书画艺术的新形式。有明一代，便于携带的“聚头”折扇风靡流行，可供赏阅亦可把玩的扇子，成为士大夫所推崇的随身雅物。清至民国，在往来应酬的文化交流中，官员世士们更是争相以画扇、赠扇、藏扇为趣，以此彰显个人的才气品位与身份地位。',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  proList: [{
    id :10,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :11,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :12,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :13,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :14,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  }]
},{
  id : '12',
  title : '扇里·扇外——中国举重博物馆藏扇面展',
  date : '2024.01.01. 09:00—2024.12.31 17:00',
  address : '中国剧中博物馆一楼临展厅',
  classify : '特展',
  ticketPrice :'免费',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner11@2x.png',
  picUrl_Nei : 'https://www.cwmuseum.cn/img/ExhibitionA1Detail05@2x.png',
  summary : '自从极具美学灵性的宋人开始在纨扇上挥洒丹青，扇画便逐渐成为中国书画艺术的新形式。有明一代，便于携带的“聚头”折扇风靡流行，可供赏阅亦可把玩的扇子，成为士大夫所推崇的随身雅物。清至民国，在往来应酬的文化交流中，官员世士们更是争相以画扇、赠扇、藏扇为趣，以此彰显个人的才气品位与身份地位。',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  proList: [{
    id :10,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :11,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :12,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :13,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :14,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  }]
},{
  id : '13',
  title : '扇里·扇外——中国举重博物馆藏扇面展',
  date : '2024.01.01. 09:00—2024.12.31 17:00',
  address : '中国剧中博物馆一楼临展厅',
  classify : '特展',
  ticketPrice :'免费',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner11@2x.png',
  picUrl_Nei : 'https://www.cwmuseum.cn/img/ExhibitionA1Detail05@2x.png',
  summary : '自从极具美学灵性的宋人开始在纨扇上挥洒丹青，扇画便逐渐成为中国书画艺术的新形式。有明一代，便于携带的“聚头”折扇风靡流行，可供赏阅亦可把玩的扇子，成为士大夫所推崇的随身雅物。清至民国，在往来应酬的文化交流中，官员世士们更是争相以画扇、赠扇、藏扇为趣，以此彰显个人的才气品位与身份地位。',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  proList: [{
    id :10,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :11,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :12,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :13,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :14,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  }]
},{
  id : '14',
  title : '扇里·扇外——中国举重博物馆藏扇面展',
  date : '2024.01.01. 09:00—2024.12.31 17:00',
  address : '中国剧中博物馆一楼临展厅',
  classify : '特展',
  ticketPrice :'免费',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner11@2x.png',
  picUrl_Nei : 'https://www.cwmuseum.cn/img/ExhibitionA1Detail05@2x.png',
  summary : '自从极具美学灵性的宋人开始在纨扇上挥洒丹青，扇画便逐渐成为中国书画艺术的新形式。有明一代，便于携带的“聚头”折扇风靡流行，可供赏阅亦可把玩的扇子，成为士大夫所推崇的随身雅物。清至民国，在往来应酬的文化交流中，官员世士们更是争相以画扇、赠扇、藏扇为趣，以此彰显个人的才气品位与身份地位。',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  proList: [{
    id :10,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :11,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :12,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :13,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :14,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  }]
},{
  id : '15',
  title : '扇里·扇外——中国举重博物馆藏扇面展',
  date : '2024.01.01. 09:00—2024.12.31 17:00',
  address : '中国剧中博物馆一楼临展厅',
  classify : '特展',
  ticketPrice :'免费',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner11@2x.png',
  picUrl_Nei : 'https://www.cwmuseum.cn/img/ExhibitionA1Detail05@2x.png',
  summary : '自从极具美学灵性的宋人开始在纨扇上挥洒丹青，扇画便逐渐成为中国书画艺术的新形式。有明一代，便于携带的“聚头”折扇风靡流行，可供赏阅亦可把玩的扇子，成为士大夫所推崇的随身雅物。清至民国，在往来应酬的文化交流中，官员世士们更是争相以画扇、赠扇、藏扇为趣，以此彰显个人的才气品位与身份地位。',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  proList: [{
    id :10,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :11,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :12,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :13,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  },{
    id :14,
    title : '扇里·扇外——中国举重博物馆藏扇面展',
    picUrl :'https://www.cwmuseum.cn/img/Exhibition18@2x.png',
  }]
}]
/* exhibitionA2特别展览结束 */
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/* exhibitionA4冠军故事开始 */
let List3 = [{
  id : '10',
  title : '第一届世界女子锦标赛挺举金牌',
  name : '陈爱珍',
  picUrl : 'https://www.cwmuseum.cn/img/Exhibition16@2x.png',
  picUrl2 : 'https://www.cwmuseum.cn/img/Exhibition17@2x.png',
}]
let Detail3 = [{
  id : '10',
  title : '第一届世界女子锦标赛挺举金牌',
  name : '陈爱珍',
  picUrl : 'https://www.cwmuseum.cn/img/Exhibition16@2x.png',
  picUrl2 : 'https://www.cwmuseum.cn/img/Exhibition17@2x.png',
  bigPicUrl :'https://www.cwmuseum.cn/img/banner11@2x.png',
  detail : '1987年10月30日至11月1日，在美国佛罗里达州举行的第一届世界女子举重锦标赛上，中国队选手陈爱珍获得挺举金牌。'
}]
/* exhibitionA4冠军故事结束 */
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/* CollectionA1馆藏精品开始 */
let List4 = [{
  id : '10',
  title : '1953年《杠铃健身法》',
  picUrl : 'https://www.cwmuseum.cn/img/Collection01@2x.png',
  classify : '奖牌',
  age : '【现代】'
},{
  id : '11',
  title : '1950年代举杠铃技术挂画',
  picUrl : 'https://www.cwmuseum.cn/img/Collection02@2x.png',
  classify : '奖杯',
  age : '【现代】'
},{
  id : '12',
  title : '1955年上海精武体育会会员证',
  picUrl : 'https://www.cwmuseum.cn/img/Collection03@2x.png',
  classify : '其他',
  age : '【现代】'
},{
  id : '13',
  title : '1955年曾维祺著《举重》',
  picUrl : 'https://www.cwmuseum.cn/img/Collection04@2x.png',
  classify : '奖牌',
  age : '【现代】'
},{
  id : '14',
  title : '画像石《力士图壁砖》',
  picUrl : 'https://www.cwmuseum.cn/img/Collection05@2x.png',
  classify : '奖杯',
  age : '【汉代】'
},{
  id : '15',
  title : '陈镜开第一次打破世界纪...',
  picUrl : 'https://www.cwmuseum.cn/img/Collection06@2x.png',
  classify : '其他',
  age : '【现代】'
}]
let Detail4 = [{
  id : '10',
  date : '2024-01-25 16:01',
  title : '【现代】1953年《杠铃健身法》',
  picUrl : 'https://www.cwmuseum.cn/img/Collection01@2x.png',
  picUrlArr : ['https://www.cwmuseum.cn/img/Collection01@2x.png'],
  address : '新体馆四楼B-03',
  classify : '奖杯',
  age : '现代',
  size : '高11CM 宽26CM',
  detail : '1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》'

},{
  id : '11',
  date : '2024-01-25 16:01',
  title : '【现代】1950年代举杠铃技术挂画',
  picUrl : 'https://www.cwmuseum.cn/img/Collection02@2x.png',
  picUrlArr : ['https://www.cwmuseum.cn/img/Collection01@2x.png','https://www.cwmuseum.cn/img/Collection02@2x.png'],
  address : '新体馆四楼B-03',
  classify : '奖杯',
  age : '现代',
  size : '高11CM 宽26CM',
  detail : '1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》'
},{
  id : '12',
  date : '2024-01-25 16:01',
  title : '【现代】1955年上海精武体育会会员证',
  picUrl : 'https://www.cwmuseum.cn/img/Collection03@2x.png',
  picUrlArr : ['https://www.cwmuseum.cn/img/Collection01@2x.png','https://www.cwmuseum.cn/img/Collection02@2x.png','https://www.cwmuseum.cn/img/Collection03@2x.png'],
  address : '新体馆四楼B-03',
  classify : '奖杯',
  age : '现代',
  size : '高11CM 宽26CM',
  detail : '1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》'

},{
  id : '13',
  date : '2024-01-25 16:01',
  title : '【现代】1955年曾维祺著《举重》',
  picUrl : 'https://www.cwmuseum.cn/img/Collection04@2x.png',
  picUrlArr : ['https://www.cwmuseum.cn/img/Collection01@2x.png','https://www.cwmuseum.cn/img/Collection02@2x.png','https://www.cwmuseum.cn/img/Collection03@2x.png','https://www.cwmuseum.cn/img/Collection04@2x.png'],
  address : '新体馆四楼B-03',
  classify : '奖杯',
  age : '现代',
  size : '高11CM 宽26CM',
  detail : '1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》'

},{
  id : '14',
  date : '2024-01-25 16:01',
  title : '【汉代】画像石《力士图壁砖》',
  picUrl : 'https://www.cwmuseum.cn/img/Collection05@2x.png',
  picUrlArr : ['https://www.cwmuseum.cn/img/Collection05@2x.png','https://www.cwmuseum.cn/img/Collection05@2x.png','https://www.cwmuseum.cn/img/Collection05@2x.png'],
  address : '新体馆四楼B-03',
  classify : '奖杯',
  age : '现代',
  size : '高11CM 宽26CM',
  detail : '1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》'

},{
  id : '15',
  date : '2024-01-25 16:01',
  title : '【现代】陈镜开第一次打破世界纪...',
  picUrl : 'https://www.cwmuseum.cn/img/Collection06@2x.png',
  picUrlArr : ['https://www.cwmuseum.cn/img/Collection06@2x.png','https://www.cwmuseum.cn/img/Collection06@2x.png','https://www.cwmuseum.cn/img/Collection06@2x.png'],
  address : '新体馆四楼B-03',
  classify : '奖杯',
  age : '现代',
  size : '高11CM 宽26CM',
  detail : '1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》1953年《杠铃健身法》'
}]
/* CollectionA1馆藏精品结束 */
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/* CollectionA2影音资料开始 */
let List5 = [{
  id : '10',
  title : '石龙陈满林1965年推举创世界纪录',
  picUrl : 'https://www.cwmuseum.cn/img/Collection10@2x.png',
  videoUrl : 'http://81.71.27.71:8003/bbb.mp4',
},{
  id : '11',
  title : '全国第二届全运会陈镜开陈满林训练',
  picUrl : 'https://www.cwmuseum.cn/img/Collection11@2x.png',
  videoUrl : 'http://81.71.27.71:8003/bbb.mp4',
},{
  id : '12',
  title : '石龙陈镜开第九次打破世界纪录新...',
  picUrl : 'https://www.cwmuseum.cn/img/Collection12@2x.png',
  videoUrl : 'http://81.71.27.71:8003/bbb.mp4',
},{
  id : '13',
  title : '石龙叶浩波打破世界纪录',
  picUrl : 'https://www.cwmuseum.cn/img/Collection13@2x.png',
  videoUrl : 'http://81.71.27.71:8003/bbb.mp4',
}]
/* CollectionA2影音资料结束 */
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/* ActivityA1活动信息开始 */
let List6 = [{
  id : '10',
  title : '活动预约 | 公益研学——搭乘探索车，一起“寻访湖湘',
  date : '2023-11-30 13:51',
  address : '中国举重博物馆',
  age : '9 岁-12 岁',
  money : '30.00',
  isOver : 0,
  picUrl : 'https://www.cwmuseum.cn/img/Activity01@2x.png',
},{
  id : '11',
  title : '活动预约 | 冬日·趣玩 在有温度的博物馆里研学',
  date : '2023-11-30 13:51',
  address : '中国举重博物馆',
  age : '9 岁-12 岁',
  money : '30.00',
  isOver : 0,
  picUrl : 'https://www.cwmuseum.cn/img/Activity02@2x.png',
},{
  id : '12',
  title : '活动预告 | 上新了艺美——指尖上的古韵雅“绘”',
  date : '2023-11-30 13:51',
  address : '中国举重博物馆',
  age : '9 岁-12 岁',
  money : '30.00',
  isOver : 1,
  picUrl : 'https://www.cwmuseum.cn/img/Activity03@2x.png',
},{
  id : '13',
  title : '活动回顾 | “世泽绵长——璜川吴氏的藏书与刻书”古籍展览专...',
  date : '2023-11-30 13:51',
  address : '中国举重博物馆',
  age : '9 岁-12 岁',
  money : '30.00',
  isOver : 1,
  picUrl : 'https://www.cwmuseum.cn/img/Activity04@2x.png',
},{
  id : '14',
  title : '活动预告 | 上新了艺美——指尖上的古韵雅“绘”',
  date : '2023-11-30 13:51',
  address : '中国举重博物馆',
  age : '9 岁-12 岁',
  money : '30.00',
  isOver : 1,
  picUrl : 'https://www.cwmuseum.cn/img/Activity03@2x.png',
}]
let Detail6 = [{
  id : '10',
  title : '活动预约 | 公益研学——搭乘探索车，一起“寻访湖湘',
  addTime : '2024-01-25 16:01',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
},{
  id : '11',
  title : '活动预约 | 公益研学——搭乘探索车，一起“寻访湖湘',
  addTime : '2024-01-25 16:01',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
},{
  id : '12',
  title : '活动预约 | 公益研学——搭乘探索车，一起“寻访湖湘',
  addTime : '2024-01-25 16:01',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
},{
  id : '13',
  title : '活动回顾 | “世泽绵长——璜川吴氏的藏书与刻书”古籍展览专...',
  addTime : '2024-01-25 16:01',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
},{
  id : '14',
  title : '活动预告 | 上新了艺美——指尖上的古韵雅“绘”',
  addTime : '2024-01-25 16:01',
  detail : '本次展览将以呈现扇画意境与扇外情谊作为切入点，揭示扇面的文化内涵。扇画题材广泛，花鸟、山水、人物、诗词皆可入扇，方寸间随形布局，展现出一种独特的艺术形式美。而在扇画意境之外，扇子本身又多了一种文化实用价值，文人墨客借扇抒情，以扇相赠，笔端描绘的景致、书写的诗句都传递着作者的情绪与心意，受赠者在欣赏、把玩扇子的同时便能感受到这份情谊。'+'<br/><br/>'+'中国举重博物馆扇面藏品以清至民国时期为主，其中湖湘名士作品极为丰富，本次展览除了从传统题材来展示扇面艺术外，还将从湖湘地域文化视角来深挖扇面的文化底蕴。“开合清风纸半张，随即舒卷岂寻常”，让我们共同走进扇画艺术的情与景，重拾扇面雅趣。',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
}]
/* ActivityA1活动信息结束 */

/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/* ExploreA1教育新闻开始 */
let List7 = [{
  id : '10',
  title : '从了解到热爱，从认知到传承 ——数万香港中小学生走进“我们的故宫”',
  detail : '2022年10月，故宫博物院与团结香港基金辖下中国文化研究院共同携手，在香港特别行政区正式推出“我们的故宫”中小学教育项目。双方结合故宫博物院以往自主开发的历史通识读本、视频等教育资源，将其转化为更适用于香港学生理解的线上教材，并赋予多元丰富的形式，包括专题展板、大挂图、短视频、动画、学习单、线上学习平台等教学资源，带领香港学生了解故宫建筑、历史、文物及其所承载的中华优秀传统文化。发布仪式上，故宫博物院院长王旭东和中国文化研究院理事会副主席、香港故宫文化博物馆董事局副主席李焯芬通过视频致辞，为项目发布致以恭贺与展望。',
  picUrl : 'https://www.cwmuseum.cn/img/Explore05@2x.png',
  addTime : '2024-01-25 16:01',
},{
  id : '11',
  title : '“故宫小书包——革命老区行” 首站走进安徽六安乡村学校',
  detail : ' 4月3日，由六安市文化和旅游局、市教育局、金寨县政府与故宫出版社共同主办的2023年“故宫小书包——革命老区行”公益捐赠活动在安徽省六安市金寨县天堂寨同心小学举行。本次活动将为六安市的200所乡村中小学送去“故宫小书包”。这也是3月27日故宫博物院“故宫小书包——革命老区行”启动仪式后的首场捐赠活动。',
  picUrl : 'https://www.cwmuseum.cn/img/Explore05@2x.png',
  addTime : '2024-01-25 16:01',
}]
let Detail7 = [{
  id : '10',
  title : '从了解到热爱，从认知到传承 ——数万香港中小学生走进“我们的故宫',
  addTime : '2024-01-25 16:01',
  detail : '2022年10月，故宫博物院与团结香港基金辖下中国文化研究院共同携手，在香港特别行政区正式推出“我们的故宫”中小学教育项目。双方结合故宫博物院以往自主开发的历史通识读本、视频等教育资源，将其转化为更适用于香港学生理解的线上教材，并赋予多元丰富的形式，包括专题展板、大挂图、短视频、动画、学习单、线上学习平台等教学资源，带领香港学生了解故宫建筑、历史、文物及其所承载的中华优秀传统文化。发布仪式上，故宫博物院院长王旭东和中国文化研究院理事会副主席、香港故宫文化博物馆董事局副主席李焯芬通过视频致辞，为项目发布致以恭贺与展望。',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
},{
  id : '11',
  title : '“故宫小书包——革命老区行” 首站走进安徽六安乡村学校',
  addTime : '2024-01-25 16:01',
  detail : ' 4月3日，由六安市文化和旅游局、市教育局、金寨县政府与故宫出版社共同主办的2023年“故宫小书包——革命老区行”公益捐赠活动在安徽省六安市金寨县天堂寨同心小学举行。本次活动将为六安市的200所乡村中小学送去“故宫小书包”。这也是3月27日故宫博物院“故宫小书包——革命老区行”启动仪式后的首场捐赠活动。',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
}]
/* ExploreA1教育新闻结束 */
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/* ExploreA2学术资讯开始 */
let List8 = [{
  id : '10',
  title : '《艺术与民俗》2019年第1期（创刊号）',
  detail : '正式发布《艺术与民俗》2019年第1期（创刊号）',
  addTime : '2024-01-25 16:01',
},{
  id : '11',
  title : '《艺术与民俗》2020年第1期',
  detail : '《艺术与民俗》2020年第1期，了解陈列设计、民俗文物及研究、艺术研究',
  addTime : '2024-01-25 16:01',
},{
  id : '12',
  title : '深圳民间文艺创新发展论坛在深圳博物馆召开',
  detail : '2019年11月29日下午，“在传承中创造——深圳民间文艺创新发展论坛”在深圳博物馆成功召开。来自中国民间文艺家协会、广东省文学艺术界联合会、广东省民间文艺家协会、深圳市文学艺术界联合会、北京和广州的艺术院校、《民艺》杂志社的领导和专家，国家级非遗项目代表性传承人，深圳各区文艺界的专家等共40多人参加了论坛。',
  addTime : '2024-01-25 16:01',
}]
let Detail8 = [{
  id : '10',
  title : '《艺术与民俗》2019年第1期（创刊号）',
  detail : '正式发布《艺术与民俗》2019年第1期（创刊号）',
  addTime : '2024-01-25 16:01',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
},{
  id : '11',
  title : '《艺术与民俗》2020年第1期',
  detail : '《艺术与民俗》2020年第1期，了解陈列设计、民俗文物及研究、艺术研究',
  addTime : '2024-01-25 16:01',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
},{
  id : '12',
  title : '深圳民间文艺创新发展论坛在深圳博物馆召开',
  detail : '2019年11月29日下午，“在传承中创造——深圳民间文艺创新发展论坛”在深圳博物馆成功召开。来自中国民间文艺家协会、广东省文学艺术界联合会、广东省民间文艺家协会、深圳市文学艺术界联合会、北京和广州的艺术院校、《民艺》杂志社的领导和专家，国家级非遗项目代表性传承人，深圳各区文艺界的专家等共40多人参加了论坛。',
  addTime : '2024-01-25 16:01',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
}]
/* ExploreA2学术资讯结束 */
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/* ExploreA3举重历史开始 */
let List9 = [{
  id : '10',
  title : '倾听林公家风 | 民族英雄林则徐的启蒙教育',
  detail : '《百年薪火——禁毒先驱林则徐家风传承展》特推出“倾听林公家风”系列专题，用声音传递林公家风，追寻历史记忆。',
  addTime : '2024-01-25 16:01',
},{
  id : '11',
  title : '漫说林公家风 | 林则徐提携后进不吝余力',
  detail : '在海战博物馆盛大开幕！为讲好林公家风故事，展览还将在线推出“漫说林公家风”专题，与观众一同走近禁毒先驱、民族英雄林则徐。',
  addTime : '2024-01-25 16:01',
}]
let Detail9 = [{
  id : '10',
  title : '倾听林公家风 | 民族英雄林则徐的启蒙教育',
  detail : '《百年薪火——禁毒先驱林则徐家风传承展》特推出“倾听林公家风”系列专题，用声音传递林公家风，追寻历史记忆。',
  addTime : '2024-01-25 16:01',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
},{
  id : '11',
  title : '漫说林公家风 | 林则徐提携后进不吝余力',
  detail : '在海战博物馆盛大开幕！为讲好林公家风故事，展览还将在线推出“漫说林公家风”专题，与观众一同走近禁毒先驱、民族英雄林则徐。',
  addTime : '2024-01-25 16:01',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
}]
/* ExploreA3举重历史结束 */
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/* NewsA1通知公告开始 */
let List10 = [{
  id: '10',
  title: '关于进一步优化进馆流程规范参观秩序的通知',
  detail: '为满足社会机构团体参观需求，我院将于2023年8月10日起针对旅游机构、教育机构、企事业单位和学校等有参观需求的单位团体开放团队预约审核通道（详见附件1），具体开放时间与散客预约通道相同，唯一预约途径为南京博物院官方网站',
  addTime: '2024-01-25 16:01',
}]
let Detail10 = [{
  id : '10',
  title : '关于进一步优化进馆流程规范参观秩序的通知',
  detail : '为满足社会机构团体参观需求，我院将于2023年8月10日起针对旅游机构、教育机构、企事业单位和学校等有参观需求的单位团体开放团队预约审核通道（详见附件1），具体开放时间与散客预约通道相同，唯一预约途径为南京博物院官方网站',
  addTime : '2024-01-25 16:01',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
}]
/* NewsA1通知公告结束 */
/* NewsA2资讯动态开始 */
let List11 = [{
  id: '10',
  title: '虎门炮台旧址第二期第二阶段修缮工程完成初步验收',
  detail: '2023年11月15日，市文化广电旅游体育局和鸦片战争博物馆共同组织召开虎门炮台旧址第二期第二阶段修缮工程初步验收。邀请了广东省文物考古研究院研究员尚杰、佛山市祖庙博物馆馆长凌建、华南理工大学建筑设计研究院高级工程师李哲扬对工程进行实地验收',
  addTime: '2024-01-25 16:01',
}]
let Detail11 = [{
  id : '10',
  title : '虎门炮台旧址第二期第二阶段修缮工程完成初步验收',
  detail : '2023年11月15日，市文化广电旅游体育局和鸦片战争博物馆共同组织召开虎门炮台旧址第二期第二阶段修缮工程初步验收。邀请了广东省文物考古研究院研究员尚杰、佛山市祖庙博物馆馆长凌建、华南理工大学建筑设计研究院高级工程师李哲扬对工程进行实地验收',
  addTime : '2024-01-25 16:01',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
}]
/* NewsA2资讯动态结束 */
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/////////////////////////////////////////////////
/* MuseumAffairsA3党建动态开始 */
let List12 = [{
  id: '10',
  title: '鸦片战争博物馆开展“铭记历史 继往开来 努力推动东莞旅游高质量发展”主题党课',
  detail: '为进一步深入学习贯彻习近平新时代中国特色社会主义思想主题教育，加强党员政治理论学习，提升政治素养。11月9日，鸦片战争博物馆党支部开展“铭记历史，继往开来，努力推动东莞旅游高质量发展”专题党课，邀请市文化广电旅游体育局二级调研员曾玉如主讲，全体党员干部参加',
  addTime: '2024-01-25 16:01',
}]
let Detail12 = [{
  id : '10',
  title : '鸦片战争博物馆开展“铭记历史 继往开来 努力推动东莞旅游高质量发展”主题党课',
  detail : '为进一步深入学习贯彻习近平新时代中国特色社会主义思想主题教育，加强党员政治理论学习，提升政治素养。11月9日，鸦片战争博物馆党支部开展“铭记历史，继往开来，努力推动东莞旅游高质量发展”专题党课，邀请市文化广电旅游体育局二级调研员曾玉如主讲，全体党员干部参加',
  addTime : '2024-01-25 16:01',
  fileArr :[{
    title : '举博官网动效说明.pdf',
    url : 'http://81.71.27.71:8003/举博官网动效说明.pdf'
  },{
    title : '举博官网-源文件.doc',
    url : 'http://81.71.27.71:8003/举博官网-源文件.doc'
  }]
}]
/* MuseumAffairsA3党建动态结束 */














export default {
  getMenu: () => {
    return {
      code: 200,
      data: [
        {
          title: "首页",
          url: "/",
          child: []
        }, {
          title: "服务",
          url: "/ServeA1",
          name: 'Serve',
          child: [{
            title: "参观指南",
            url: "/ServeA1",
            name: "ServeA1",
            icon: "https://www.cwmuseum.cn/img/Serve01@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Serve01_active@2x.png",
          }, {
            title: "门票预约",
            url: "/ServeA2",
            name: "ServeA2",
            icon: "https://www.cwmuseum.cn/img/Serve02@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Serve02_active@2x.png",
          }, {
            title: "交通路线",
            url: "/ServeA3",
            name: "ServeA3",
            icon: "https://www.cwmuseum.cn/img/Serve03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Serve03_active@2x.png",
          }]
        }, {
          title: "展览",
          url: "/ExhibitionA1",
          name: 'Exhibition',
          child: [{
            title: "基本陈列",
            url: "/ExhibitionA1",
            name: "ExhibitionA1",
            icon: "https://www.cwmuseum.cn/img/Exhibition01@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Exhibition01_active@2x.png",
          }, {
            title: "特别展览",
            url: "/ExhibitionA2",
            name: "ExhibitionA2",
            icon: "https://www.cwmuseum.cn/img/Exhibition02@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Exhibition02_active@2x.png",
          }, {
            title: "云上举博",
            url: "/ExhibitionA3",
            name: "ExhibitionA3",
            icon: "https://www.cwmuseum.cn/img/Exhibition03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Exhibition03_active@2x.png",
          }, {
            title: "冠军故事",
            url: "/ExhibitionA4",
            name: "ExhibitionA4",
            icon: "https://www.cwmuseum.cn/img/Exhibition15@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Exhibition15_active@2x.png",
          }]
        }, {
          title: "藏品",
          url: "/CollectionA1",
          name: 'Collection',
          child: [{
            title: "馆藏精品",
            url: "/CollectionA1",
            name: "CollectionA1",
            icon: "https://www.cwmuseum.cn/img/Collection07@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Collection07_active@2x.png",
          }, {
            title: "影音资料",
            url: "/CollectionA2",
            name: "CollectionA2",
            icon: "https://www.cwmuseum.cn/img/Collection08@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Collection08_active@2x.png",
          }]
        }, {
          title: "活动",
          url: "/ActivityA1",
          name: 'Activity',
          hidden : true,
          child: [{
            title: "活动信息",
            url: "/ActivityA1",
            name: "/ActivityA1",
            icon: "https://www.cwmuseum.cn/img/Serve03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Serve03_active@2x.png",
          }]
        }, {
          title: "探索",
          url: "/ExploreA1",
          name: 'Explore',
          child: [{
            title: "举重新闻",
            url: "/ExploreA1",
            name: "ExploreA1",
            icon: "https://www.cwmuseum.cn/img/Explore01@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Explore01_active@2x.png",
          }, {
            title: "学术资讯",
            hidden : true,
            url: "/ExploreA2",
            name: "ExploreA2",
            icon: "https://www.cwmuseum.cn/img/Explore02@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Explore02_active@2x.png",
          }, {
            title: "举重历史",
            url: "/ExploreA3",
            name: "ExploreA3",
            icon: "https://www.cwmuseum.cn/img/Explore03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Explore03_active@2x.png",
          }]
        }, {
          title: "文创",
          url: "/ShopA1",
          name: 'Shop',
          child: [{
            title: "文创商店",
            url: "/ShopA1",
            name: "ShopA1",
            icon: "https://www.cwmuseum.cn/img/Serve03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Serve03_active@2x.png",
          }]
        }, {
          title: "资讯",
          url: "/NewsA1",
          name: 'News',
          child: [{
            title: "通知公告",
            url: "/NewsA1",
            name: "NewsA1",
            icon: "https://www.cwmuseum.cn/img/News01@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/News01_active@2x.png",
          }, {
            title: "资讯动态",
            url: "/NewsA2",
            name: "NewsA2",
            icon: "https://www.cwmuseum.cn/img/News02@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/News02_active@2x.png",
          }]
        }, {
          title: "馆务",
          url: "/MuseumAffairsA1",
          name: 'MuseumAffairs',
          child: [{
            title: "本馆概况",
            url: "/MuseumAffairsA1",
            name: 'MuseumAffairsA1',
            icon: "https://www.cwmuseum.cn/img/MuseumAffairs01@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/MuseumAffairs01_active@2x.png",
          }, {
            title: "机构职能",
            hidden : true,
            url: "/MuseumAffairsA2",
            name: "MuseumAffairsA2",
            icon: "https://www.cwmuseum.cn/img/MuseumAffairs02@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/MuseumAffairs02_active@2x.png",
          }, {
            title: "党建动态",
            hidden : true,
            url: "/MuseumAffairsA3",
            name: "MuseumAffairsA3",
            icon: "https://www.cwmuseum.cn/img/MuseumAffairs03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/MuseumAffairs03_active@2x.png",
          }, {
            title: "大事记",
            url: "/MuseumAffairsA4",
            name: "MuseumAffairsA4",
            icon: "https://www.cwmuseum.cn/img/MuseumAffairs04@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/MuseumAffairs04_active@2x.png",
          }]
        }, {
          title: "搜索结果",
          url: "/Search",
          name: 'Search',
        }
      ],
    }
  },
  getMenuEn: () => {
    return {
      code: 200,
      data: [
        {
          title: "Home",
          url: "/",
          child: []
        }, {
          title: "Serve",
          url: "/ServeA1",
          name: 'Serve',
          child: [{
            title: "Fingerpost",
            url: "/ServeA1",
            name: "ServeA1",
            icon: "https://www.cwmuseum.cn/img/Serve01@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Serve01_active@2x.png",
          }, {
            title: "Tickets",
            url: "/ServeA2",
            name: "ServeA2",
            icon: "https://www.cwmuseum.cn/img/Serve02@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Serve02_active@2x.png",
          }]
          // , {
          // title: "Traffic",
          // url: "/ServeA3",
          // name: "ServeA3",
          // icon: "https://www.cwmuseum.cn/img/Serve03@2x.png",
          // icon_current: "https://www.cwmuseum.cn/img/Serve03_active@2x.png",
        // }
        }, {
          title: "Exhibition",
          url: "/ExhibitionA1",
          name: 'Exhibition',
          child: [{
            title: "Basic",
            url: "/ExhibitionA1",
            name: "ExhibitionA1",
            icon: "https://www.cwmuseum.cn/img/Exhibition01@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Exhibition01_active@2x.png",
          }, {
            title: "Special",
            url: "/ExhibitionA2",
            name: "ExhibitionA2",
            icon: "https://www.cwmuseum.cn/img/Exhibition02@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Exhibition02_active@2x.png",
          }, {
            title: "JuBo Cloud",
            url: "/ExhibitionA3",
            name: "ExhibitionA3",
            icon: "https://www.cwmuseum.cn/img/Exhibition03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Exhibition03_active@2x.png",
          }, {
            title: "Champion",
            url: "/ExhibitionA4",
            name: "ExhibitionA4",
            icon: "https://www.cwmuseum.cn/img/Exhibition15@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Exhibition15_active@2x.png",
          }]
        }, {
          title: "Collection",
          url: "/CollectionA1",
          name: 'Collection',
          child: [{
            title: "Boutique",
            url: "/CollectionA1",
            name: "CollectionA1",
            icon: "https://www.cwmuseum.cn/img/Collection07@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Collection07_active@2x.png",
          }, {
            title: "Kmplayer",
            url: "/CollectionA2",
            name: "CollectionA2",
            icon: "https://www.cwmuseum.cn/img/Collection08@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Collection08_active@2x.png",
          }]
        }, {
          title: "Activity",
          url: "/ActivityA1",
          name: 'Activity',
          hidden:true,
          child: [{
            title: "Message",
            url: "/ActivityA1",
            name: "/ActivityA1",
            icon: "https://www.cwmuseum.cn/img/Serve03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Serve03_active@2x.png",
          }]
        }, {
          title: "Explore",
          url: "/ExploreA1",
          name: 'Explore',
          child: [{
            title: "Journalism",
            url: "/ExploreA1",
            name: "ExploreA1",
            icon: "https://www.cwmuseum.cn/img/Explore01@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Explore01_active@2x.png",
          }, {
            title: "Academic",
            hidden : true,
            url: "/ExploreA2",
            name: "ExploreA2",
            icon: "https://www.cwmuseum.cn/img/Explore02@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Explore02_active@2x.png",
          }, {
            title: "History",
            url: "/ExploreA3",
            name: "ExploreA3",
            icon: "https://www.cwmuseum.cn/img/Explore03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Explore03_active@2x.png",
          }]
        }, {
          title: "Shop",
          url: "/ShopA1",
          name: 'Shop',
          child: [{
            title: "Shop",
            url: "/ShopA1",
            name: "ShopA1",
            icon: "https://www.cwmuseum.cn/img/Serve03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/Serve03_active@2x.png",
          }]
        }, {
          title: "Message",
          url: "/NewsA1",
          name: 'News',
          child: [{
            title: "Notice",
            url: "/NewsA1",
            name: "NewsA1",
            icon: "https://www.cwmuseum.cn/img/News01@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/News01_active@2x.png",
          }, {
            title: "Dynamic",
            url: "/NewsA2",
            name: "NewsA2",
            icon: "https://www.cwmuseum.cn/img/News02@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/News02_active@2x.png",
          }]
        }, {
          title: "Museum",
          url: "/MuseumAffairsA1",
          name: 'MuseumAffairs',
          child: [{
            title: "Survey",
            url: "/MuseumAffairsA1",
            name: 'MuseumAffairsA1',
            icon: "https://www.cwmuseum.cn/img/MuseumAffairs01@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/MuseumAffairs01_active@2x.png",
          }, {
            title: "Organization",
            hidden : true,
            url: "/MuseumAffairsA2",
            name: "MuseumAffairsA2",
            icon: "https://www.cwmuseum.cn/img/MuseumAffairs02@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/MuseumAffairs02_active@2x.png",
          }, {
            title: "Trends",
            hidden : true,
            url: "/MuseumAffairsA3",
            name: "MuseumAffairsA3",
            icon: "https://www.cwmuseum.cn/img/MuseumAffairs03@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/MuseumAffairs03_active@2x.png",
          }, {
            title: "Events ",
            url: "/MuseumAffairsA4",
            name: "MuseumAffairsA4",
            icon: "https://www.cwmuseum.cn/img/MuseumAffairs04@2x.png",
            icon_current: "https://www.cwmuseum.cn/img/MuseumAffairs04_active@2x.png",
          }]
        }, {
          title: "Search Result",
          url: "/Search",
          name: 'Search',
        }
      ],
    }
  },
  getBanner: () => {
    return {
      code: 200,
      data: [{
        name_zh:"服务banner",
        name: "Serve",
        url: 'https://www.cwmuseum.cn/img/banner01@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"基本陈列banner",
        name: "ExhibitionA1",
        url: 'https://www.cwmuseum.cn/img/banner02@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"基本陈列详情banner",
        name: "ExhibitionA1Detail",
        url: 'https://www.cwmuseum.cn/img/banner10@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"特别展览banner",
        name: "ExhibitionA2",
        url: 'https://www.cwmuseum.cn/img/banner03@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"特别展览详情banner",
        name: "ExhibitionA2Detail",
        url: 'https://www.cwmuseum.cn/img/banner11@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"冠军故事banner",
        name: "ExhibitionA4",
        url: 'https://www.cwmuseum.cn/img/banner03@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"冠军故事详情banner",
        name: "ExhibitionA4Detail",
        url: 'https://www.cwmuseum.cn/img/banner03@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"藏品banner",
        name: "Collection",
        url: 'https://www.cwmuseum.cn/img/banner04@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"活动banner",
        name: "Activity",
        url: 'https://www.cwmuseum.cn/img/banner05@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"探索banner",
        name: "Explore",
        url: 'https://www.cwmuseum.cn/img/banner06@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"文创banner",
        name: "Shop",
        url: 'https://www.cwmuseum.cn/img/banner07@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"资讯banner",
        name: "News",
        url: 'https://www.cwmuseum.cn/img/banner08@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"馆务banner",
        name: "MuseumAffairs",
        url: 'https://www.cwmuseum.cn/img/banner09@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }, {
        name_zh:"搜索banner",
        name: "Search",
        url: 'https://www.cwmuseum.cn/img/banner08@2x.png',
        urlEn: 'https://www.cwmuseum.cn/img/banner01@2x.png'
      }],
    }
  },
  // 基本陈列
  getExhibitionA1: config => {
    //limit默认是6，因为分页器默认也是一页6个
    const {name, page=1, limit=6} = JSON.parse(config.body)

    const mockList = List.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (name && user.name.indexOf(name) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getExhibitionA1Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
  // 特别展览
  getExhibitionA2: config => {
    //limit默认是6，因为分页器默认也是一页6个
    const {name, page=1, limit=6} = JSON.parse(config.body)

    const mockList = List2.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (name && user.name.indexOf(name) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getExhibitionA2Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail2.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
  // 冠军故事
  getExhibitionA4: config => {
    //limit默认是6，因为分页器默认也是一页6个
    const {name, page=1, limit=6} = JSON.parse(config.body)

    const mockList = List3.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (name && user.name.indexOf(name) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getExhibitionA4Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail3.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
  // 馆藏精品
  getCollectionA1: config => {
    //limit默认是6，因为分页器默认也是一页6个
    const {classify, page=1, limit=6} = JSON.parse(config.body)

    const mockList = List4.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (classify && user.classify.indexOf(classify) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getCollectionA1Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail4.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
  // 影音资料
  getCollectionA2: config => {
    //limit默认是6，因为分页器默认也是一页6个
    const {classify, page=1, limit=6} = JSON.parse(config.body)

    const mockList = List5.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (classify && user.classify.indexOf(classify) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  // 活动信息
  getActivityA1: config => {
    //limit默认是5，因为分页器默认也是一页5个
    const {classify, page=1, limit=5} = JSON.parse(config.body)

    const mockList = List6.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (classify && user.classify.indexOf(classify) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getActivityA1Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail6.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
  // 教育新闻
  getExploreA1: config => {
    //limit默认是5，因为分页器默认也是一页5个
    const {classify, page=1, limit=5} = JSON.parse(config.body)

    const mockList = List7.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (classify && user.classify.indexOf(classify) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getExploreA1Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail7.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
  // 学术资讯
  getExploreA2: config => {
    //limit默认是5，因为分页器默认也是一页5个
    const {classify, page=1, limit=5} = JSON.parse(config.body)

    const mockList = List8.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (classify && user.classify.indexOf(classify) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getExploreA2Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail8.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
  // 举重历史
  getExploreA3: config => {
    //limit默认是5，因为分页器默认也是一页5个
    const {classify, page=1, limit=5} = JSON.parse(config.body)

    const mockList = List9.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (classify && user.classify.indexOf(classify) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getExploreA3Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail9.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
  // 通知公告
  getNewsA1: config => {
    //limit默认是5，因为分页器默认也是一页5个
    const {classify, page=1, limit=5} = JSON.parse(config.body)

    const mockList = List10.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (classify && user.classify.indexOf(classify) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getNewsA1Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail10.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
  // 资讯动态
  getNewsA2: config => {
    //limit默认是5，因为分页器默认也是一页5个
    const {classify, page=1, limit=5} = JSON.parse(config.body)

    const mockList = List11.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (classify && user.classify.indexOf(classify) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getNewsA2Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail11.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
  // 党建动态
  getMuseumAffairsA3: config => {
    //limit默认是5，因为分页器默认也是一页5个
    const {classify, page=1, limit=5} = JSON.parse(config.body)

    const mockList = List12.filter(user => {
      // 如果name存在会，根据name筛选数据
      if (classify && user.classify.indexOf(classify) === -1) return false
      return true
    })
    // 分页
    const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))
    return {
      code: 200,
      data: {
        list: pageList,
        count: mockList.length, //数据总条数需要返回
      }
    }
  },
  getMuseumAffairsA3Detail: config => {
    const {id} = JSON.parse(config.body)
    const data = Detail12.filter((item, index) =>item.id == id )
    return {
      code: 200,
      data: data[0]
    }
  },
}




// WEBPACK FOOTER //
// ./src/api/mockData/home.js